'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var fontStack = exports.fontStack = {
	fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif'
};

var fontStackHeaders = exports.fontStackHeaders = {
	fontFamily: 'Roboto Slab, Helvetica, sans-serif'
};

var body = exports.body = {
	fontSize: '14px',
	lineHeight: '20px'
};

var small = exports.small = {
	fontSize: '12px',
	lineHeight: '17px'
};

var button = exports.button = {
	letterSpacing: '0.5px'
};

exports.default = {
	fontStack: fontStack,
	fontStackHeaders: fontStackHeaders,
	body: body,
	small: small,
	button: button
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/styles/typography.styles.js